// import { useState, useEffect } from "react";
// import { Navigate } from 'react-router-dom';
// import axios from 'axios';
// import {url,urlLive} from '../../../constant';

// // react-router-dom components
// import { Link } from "react-router-dom";

// //  @mui material full-page-loader
// import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';


// // @mui material components
// import Card from "@mui/material/Card";
// import Checkbox from "@mui/material/Checkbox";

// // Material Dashboard 2 React components
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDButton from "components/MDButton";

// // Authentication layout components
// import CoverLayout from "layouts/authentication/components/CoverLayout";
// import BasicLayout from "layouts/authentication/components/BasicLayout";

// // Images
// import bgImage from "assets/images/bg-sign-in-basic.jpeg";

// function SignUp() {
//   const [loggedIN, setLoggedIN] = useState(false);
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [phone, setPhone] = useState('');
//   // const [email, setEmail] = useState('rizwaneng6@gmail.com');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [passwordConfirmation, setPasswordConfirmation] = useState('');
//   const [open, setOpen] = useState(false);

//   const [birthDate, setBirthDate] = useState('');
//   const [companyId, setCompanyId] = useState('');
//   const [isAdminCompany, setIsAdminCompany] = useState(false);
//   const [isAdminPlatform, setIsAdminPlatform] = useState(false);

//   useEffect(() => {
//     const udata = localStorage.getItem('user');
//     if (udata !== null) {
//       setLoggedIN(true);
//     }
//   }, []);

//   // Form validation function
//   const validateForm = () => {
//     if (firstName.length < 2 || firstName.length > 20) {
//       alert("First-name should be between 2-20 characters");
//       return false;
//     }
//     if (lastName.length < 2 || lastName.length > 20) {
//       alert("Last-name should be between 2-20 characters");
//       return false;
//     }
//     if (phone.length < 5 || phone.length > 12) {
//       alert("Phone number should be between 5-12 digits");
//       return false;
//     }
//     if (password.length < 6) {
//       alert("Password should be greater than 5 characters");
//       return false;
//     }
//     if (password !== passwordConfirmation) {
//       alert("Enter the same password in both fields");
//       return false;
//     }
//     return true;
//   };

//   // Form submit handler
//   const onSubmit = (e) => {
//     e.preventDefault();

//     // if (!validateForm()) {
//     //   return; // Stop submission if validation fails
//     // }

//     const userObject = {
//       first_name: firstName,
//       last_name: lastName,
//       phone: phone,
//       email: email,
//       password: password,
//       password_confirmation: passwordConfirmation,
//     };

//     setOpen(true);
//     axios.post(`${url}auth/register`, userObject)
//       .then((res) => {
//         console.log(res, "Registration Response");
//         if (res.data.message === "Utente registrato") {
//           setOpen(false);  // Hide backdrop in case of error
//           alert("Registration Successful");
//           window.location = "/sign-in"; // Redirect to sign-in page
//         }
//       }).catch((error) => {
//         setOpen(false);  // Hide backdrop in case of error
//         // console.log(JSON.parse(error));
//         console.log(error.response.data);
//         const errorMessage = error.response.data;
        
//           alert(errorMessage.error);

//       }); 

//     // Clear the form fields
//     setFirstName('');
//     setLastName('');
//     setPhone('');
//     setEmail('');
//     setPassword('');
//     setPasswordConfirmation('');
//   };

//   if (loggedIN) {
//     return <Navigate to="/dashboard" />;
//   }

//   return (
//     <BasicLayout>
//       <Backdrop
//         sx={{
//           color: '#fff',
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//           backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
//         }}

//         open={open}
//         transitionDuration={500}  // Smooth transition for the backdrop
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop>
//       <Card>
//         <MDBox
//           variant="gradient"
//           bgColor="info"
//           borderRadius="lg"
//           coloredShadow="success"
//           mx={2}
//           mt={-3}
//           p={3}
//           mb={1}
//           textAlign="center"
//           sx={{
//             background: '#6281eb', // Initial background color
//             "&:hover": {
//               background: '#4a65d8', // Hover state color
//             },
//           }}
//         >
//           <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
//             Join us today
//           </MDTypography>
//           <MDTypography display="block" variant="button" color="white" my={1}>
//             Enter your email and password to register
//           </MDTypography>
//         </MDBox>
//         <MDBox pt={4} pb={3} px={3}>
//           <MDBox component="form" role="form" onSubmit={onSubmit}>
//             <MDBox mb={2}>
//               <MDInput
//                 type="text"
//                 label="First Name"
//                 variant="standard"
//                 fullWidth
//                 value={firstName}
//                 onChange={(e) => setFirstName(e.target.value)}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput
//                 type="text"
//                 label="Last Name"
//                 variant="standard"
//                 fullWidth
//                 value={lastName}
//                 onChange={(e) => setLastName(e.target.value)}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput
//                 type="text"
//                 label="Phone Number"
//                 variant="standard"
//                 fullWidth
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput
//                 type="email"
//                 label="Email"
//                 variant="standard"
//                 fullWidth
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput
//                 type="password"
//                 label="Password"
//                 variant="standard"
//                 fullWidth
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput
//                 type="password"
//                 label="Confirm Password"
//                 variant="standard"
//                 fullWidth
//                 value={passwordConfirmation}
//                 onChange={(e) => setPasswordConfirmation(e.target.value)}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput
//                 type="date"
//                 label="Birth Date"
//                 variant="standard"
//                 fullWidth
//                 value={birthDate}
//                 onChange={(e) => setBirthDate(e.target.value)}
//               />
//             </MDBox>

//             <MDBox mb={2}>
//               <MDInput
//                 type="text"
//                 label="Company ID"
//                 variant="standard"
//                 fullWidth
//                 value={companyId}
//                 onChange={(e) => setCompanyId(e.target.value)} // Assuming a list of companies is available
//               />
//             </MDBox>

//             <MDBox mb={2}>
//               <Checkbox
//                 checked={isAdminCompany}
//                 onChange={(e) => setIsAdminCompany(e.target.checked)}
//                 value="isAdminCompany"
//                 inputProps={{ 'aria-label': 'Is Admin for Company' }}
//               />
//               <MDTypography variant="body2">Admin of Company</MDTypography>
//             </MDBox>

//             <MDBox mb={2}>
//               <Checkbox
//                 checked={isAdminPlatform}
//                 onChange={(e) => setIsAdminPlatform(e.target.checked)}
//                 value="isAdminPlatform"
//                 inputProps={{ 'aria-label': 'Is Admin of Platform' }}
//               />
//               <MDTypography variant="body2">Admin of Platform</MDTypography>
//             </MDBox>
//             <MDBox mt={4} mb={1}>
//               <MDButton
//                 variant="gradient"
//                 color="info"
//                 sx={{
//                   background: '#6281eb', // Initial background color
//                   "&:hover": {
//                     background: '#4a65d8', // Hover state color
//                   },
//                 }}
//                 fullWidth
//                 type="submit"
//               >
//                 Sign Up
//               </MDButton>
//             </MDBox>
//             <MDBox mt={3} mb={1} textAlign="center">
//               <MDTypography variant="button" color="text">
//                 Already have an account?{" "}
//                 <MDTypography
//                   component={Link}
//                   to="/authentication/sign-in"
//                   variant="button"
//                   color="info"
//                   fontWeight="medium"
//                   textGradient
//                   sx={{
//                     background: 'linear-gradient(to right, #6281eb, #4a65d8)', // Gradient color
//                     WebkitBackgroundClip: 'text',
//                     color: 'transparent', // Ensures that the text is transparent so that the gradient is visible
//                   }}
//                 >
//                   Log in
//                 </MDTypography>
//               </MDTypography>
//             </MDBox>
//           </MDBox>
//         </MDBox>
//       </Card>
//     </BasicLayout>
//   );
// }

// export default SignUp;


import React, { useState, useEffect } from "react";
import { Navigate } from 'react-router-dom';

import { url, urlLive } from "../../../constant";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import Backdrop from '@mui/material/Backdrop';

import { Box, FormControl, FormControlLabel, RadioGroup, Radio,  InputLabel, Select, MenuItem, TextField, Stack, Button,CircularProgress  } from '@mui/material';
import Grid from '@mui/material/Grid'; // Material-UI grid for responsive layout

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs'; 
import 'dayjs/locale/en-gb'; // Import the locale for British English


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";


function SignUp() {
  const [loggedIN, setLoggedIN] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [open, setOpen] = useState(false);
  const [birthDate, setBirthDate] = useState(null);
  const [companyId, setCompanyId] = useState('');
  const [isAdminCompany, setIsAdminCompany] = useState(false);
  const [isAdminPlatform, setIsAdminPlatform] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [activeCompanies, setActiveCompanies] = useState([]);

  const [isLoading, setIsLoading] = React.useState(false);
  const [Active, setActive] = React.useState(true);

  const [isEmailEnabled, setIsEmailEnabled] = React.useState(false); // State for email toggle

  useEffect(() => {
    const udata = localStorage.getItem('user');
    if (udata !== null) {
      setLoggedIN(true);
    }
  }, []);

  // Fetch company and category options
  React.useEffect(() => {
    
    // fetchCompanies();
    getActiveCompaines();
    
  }, []);

  React.useEffect(() => {
    getEmailNotificationStatus();
  }, []);

  const getEmailNotificationStatus = () => {

    fetch(`${url}auth/settings/email-notification`)
      .then(response => response.json())
      .then(data => {
        console.log('EmailNotificationStatus :', data);
        setIsEmailEnabled(data.email_notification_enabled);
      });

  };

  const validateForm = () => {
    // First Name Validation
    if (firstName.length < 2 || firstName.length > 20) {
      alert("First-name should be between 2-20 characters");
      return false;
    }

    // Last Name Validation
    if (lastName.length < 2 || lastName.length > 20) {
      alert("Last-name should be between 2-20 characters");
      return false;
    }

    // Phone Number Validation (Should be between 5-12 digits)
    if (phone.length < 5 || phone.length > 12 || !/^\d+$/.test(phone)) {
      alert("Phone number should be between 5-12 digits and contain only numbers");
      return false;
    }

    // Email Validation (Check for valid email format)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address");
      return false;
    }

    // Password Validation (Should be greater than 5 characters)
    if (password.length < 6) {
      alert("Password should be greater than 5 characters");
      return false;
    }

    // Confirm Password Validation (Should match the password)
    if (password !== passwordConfirmation) {
      alert("Enter the same password in both fields");
      return false;
    }

    // Birth Date Validation (Cannot be empty)
    if (!birthDate) {
      alert("Please select your birth date");
      return false;
    }

    // Company ID Validation (Must be selected)
    if (!companyId) {
      alert("Please select a company");
      return false;
    }

    // If all validations pass, return true
    return true;
  };
  

  // Function to reset the form
  const resetForm = () => {
    
    setFirstName('');
    setLastName('');
    setPhone('');
    setEmail('');
    setPassword('');
    setPasswordConfirmation('');
    setOpen(false);
    setBirthDate(null);
    setCompanyId('');
    setIsAdminCompany(false);
    setIsAdminPlatform(false);
    setCompanies([]); // Reset the companies if needed

  };

  // Form submit handler
  const onSubmit = (e) => {
    e.preventDefault();

    setOpen(true);

    if (1){

      const formData = new FormData();
      formData.append("first_name", firstName);
      formData.append("last_name", lastName);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("password_confirmation", passwordConfirmation);
      formData.append("birth_date",  birthDate ? birthDate.format('YYYY-MM-DD') : '');
      formData.append("company_id", companyId); // Send company ID, if provided
      formData.append("is_email_enabled", isEmailEnabled);
      

      if (isAdminCompany) {
        
        formData.append("is_admin_platform", (isAdminPlatform) ? 1 : 0); // !isAdminPlatform
        formData.append("is_admin_company", (isAdminCompany) ? 1 : 0); //!isAdminCompany
        formData.append("is_active", (Active) ? 1 : 0);
      } else {

        formData.append("is_admin_company", (isAdminCompany) ? 1 : 0);
        formData.append("is_admin_platform", (isAdminPlatform) ? 1 : 0);
        formData.append("is_active", (Active) ? 1 : 0);

      }

      // Send the data to the backend via fetch
      const requestOptions = {
        method: "POST",    // POST method for submitting data
        body: formData, // Use the formData object as the body of the request
      };

      fetch(`${url}auth/register`, requestOptions)
        .then((response) => response.json()) // Parse the response as JSON
        .then((result) => {
          if (result.message) {
            // On success, handle the result here
            console.log(result.message);
            console.log("User Details:", result.user);
            // Optionally, reset the form or redirect
            resetForm();
            alert(result.message); // You can show a success alert here
          } else if (result.error) {
            // Show error message if the backend sends an error
            console.log("Error:", result.error);
            alert(result.error); // Show the backend error message in an alert
          }
        })
        .catch((error) => {
          // Handle any other errors
          console.error("Error during fetch:", error);
          alert("An error occurred while registering. Please try again later.");
        })
        .finally(() => {
          setOpen(false);
        });


    }


    // Clear the form fields
    // setFirstName('');
    // setLastName('');
    // setPhone('');
    // setEmail('');
    // setPassword('');
    // setPasswordConfirmation('');
    // setBirthDate(null);

  };

  const fetchCompanies = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${url}auth/get-companies`);
      const data = await response.json();
      setCompanies(data.companies || []);
      
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getActiveCompaines = () => {

    setIsLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-companies?IsActive=true`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.companies) {
          setActiveCompanies(result.companies || []);
        }
      })
      .catch((error) => console.error("Error fetching companies:", error))
      .finally(() => {
        setIsLoading(false);  // Hide loader after fetching
      });

  }

  const handleCompanyChange = (event) => {
    setCompanyId(event.target.value);
  };

  const handleBirthDateChange = (newValue) => {
    setBirthDate(newValue);
  };

  // if (loggedIN) {
  //   return <Navigate to="/dashboard" />;
  // }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Grid justifyContent="center" container spacing={6}>
        <Grid item xs={10}>
          <Backdrop
            sx={{
              color: '#fff',
              zIndex: (theme) => theme.zIndex.drawer + 1,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}
            open={open}
            transitionDuration={500}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <Card>

            <MDBox
              variant="gradient"
              // bgColor="info"  
              bgColor="#183759"
              borderRadius="lg"
              mx={2}
              mt={2}
              p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                {/* Join us today */}
                Registrazione
              </MDTypography>
              <MDTypography display="block" variant="button" color="white" my={1}>
                {/* Enter your email and password to register */}
                Inserisci i tuoi dati per registrarti
              </MDTypography>
            </MDBox>
            
            <MDBox pt={4} pb={3} px={3}>
              <MDBox component="form" role="form" onSubmit={onSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      // label="First Name"
                      label="Nome"
                      variant="standard"
                      fullWidth
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      // label="Last Name" 
                      label="Cognome"
                      variant="standard"
                      fullWidth
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      // label="Phone Number"
                      label="Telefono"
                      variant="standard"
                      fullWidth
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="email"
                      label="Email"
                      variant="standard"
                      fullWidth
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="password"
                      label="Password"
                      variant="standard"
                      fullWidth
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="password"
                      // label="Confirm Password"
                      label="Conferma password"
                      variant="standard"
                      fullWidth
                      value={passwordConfirmation}
                      onChange={(e) => setPasswordConfirmation(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>


                    <MDBox mt={-1}>
                      <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                          <DemoContainer components={['DatePicker']}>
                            <DatePicker
                              sx={{ width: '100%' }}
                              // label="Birth Date"
                              label="Data di nascita"
                              value={birthDate}
                              onChange={handleBirthDateChange}

                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </FormControl>
                    </MDBox>

                  </Grid>
                  <Grid item xs={12} md={6}>

                    <MDBox>
                      <FormControl fullWidth>
                        {/* <InputLabel id="company-select-label">Company</InputLabel>  */}
                        <InputLabel id="company-select-label">Azienda</InputLabel>
                          
                          {/* <Select
                            labelId="company-select-label"
                            id="company-select"
                            value={companyId}
                            label="Company"
                            onChange={handleCompanyChange}
                            style={{ height: 45 }}
                          >
                            <MenuItem value={22}>Company 1</MenuItem>
                            <MenuItem value={23}>Company 2</MenuItem>
                            <MenuItem value={24}>Company 3</MenuItem>
                          </Select> */}

                          <Select
                            labelId="company-select-label"
                            id="company-select"
                            value={companyId}
                            label="Company"
                            onChange={handleCompanyChange}
                            style={{ height: 45 }}
                            sx={{
                              '& .MuiSelect-icon': {
                                display: 'block !important',  // Force icon to be visible
                                fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                              },
                            }}
                            IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                          >
                            {/* <MenuItem disabled>Select Company</MenuItem> */}
                            {isLoading ? (
                              <MenuItem disabled>
                                <CircularProgress size={24} sx={{ mr: 1 }} />
                                Loading...
                              </MenuItem>
                            ) : activeCompanies.length > 0 ? (
                              activeCompanies.map((comp) => (
                                <MenuItem key={comp.IdCompany} value={comp.IdCompany}>
                                  {comp.CompanyName}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>No companies available</MenuItem>
                            )}
                          </Select>

                      </FormControl>
                    </MDBox>

                  </Grid>

                  <Grid item xs={12} md={6}>
                    <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={isAdminCompany}
                        onChange={(e) => setIsAdminCompany(e.target.checked)}
                        sx={{
                          mr: 1,
                          '&.Mui-checked .MuiSvgIcon-root': {
                            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                            borderColor: '#344767',
                          },
                        }} // Adds spacing between checkbox and text
                      />
                      {/* <MDTypography variant="body2">Company Administrator</MDTypography> */}
                      <MDTypography variant="body2">Amministratore azienda</MDTypography>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={isAdminPlatform}
                        onChange={(e) => setIsAdminPlatform(e.target.checked)}
                        sx={{
                          mr: 1,
                          '&.Mui-checked .MuiSvgIcon-root': {
                            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                            borderColor: '#344767',
                          },
                        }} // Adds spacing between checkbox and text
                      />
                      {/* <MDTypography variant="body2">Administrator</MDTypography>  */}
                      <MDTypography variant="body2">Amministratore</MDTypography>

                    </MDBox>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={Active}
                        // color="default"
                        onChange={(e) => setActive(e.target.checked)}
                        sx={{
                          mr: 1,
                          '&.Mui-checked .MuiSvgIcon-root': {
                            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                            borderColor: '#344767',
                          },
                        }} // Adds spacing between checkbox and text

                      />
                      {/* <MDTypography variant="body2">Active</MDTypography> */}
                      <MDTypography variant="body2">Attivo</MDTypography>
                    </MDBox>
                    
                  </Grid>

                  

                  <Grid item xs={12}>

                    <Button
                      variant="gradient"
                      // color="info"
                      fullWidth
                      type="submit"
                      sx={{
                        color:'#fff',
                        backgroundColor: '#183759',
                        '&:hover': {
                          backgroundColor: '#204b80', // Subtle hover shade
                        },
                        transition: 'background-color 0.3s ease-in-out',
                        // textTransform: 'none'
                      }}

                    >
                      {/* Sign Up */}
                      {/* Register */}
                      Salva
                    </Button>

                  </Grid>
                </Grid>
                {/* <MDBox mt={3} mb={1} textAlign="center">
                    <MDTypography variant="button" color="text">
                      Already have an account?{" "}
                      <MDTypography
                        component={Link}
                        to="/authentication/sign-in"
                        variant="button"
                        color="info"
                        fontWeight="medium"
                        textGradient
                      >
                        Log in
                      </MDTypography>
                    </MDTypography>
                  </MDBox> */}
                
              </MDBox>
            </MDBox>
          </Card>

        </Grid>

      </Grid>
    </DashboardLayout>

  );
}

export default SignUp;
